import { CUSTOM_EVENTS, LQ_EVENTS } from '@/const/events';
import { TEST_DIVIDER } from '@/const/laquesis';
import { getLQDefinition, writeLQDefinition } from '@/cookies/laquesis/lqstatus';
import { getLogger } from '@/logger';
import { dataLayer } from '@/ninja/dataLayer';
import { state } from '@/ninja/state';
import { ClickEvent } from '@/types/events';
import { triggerCustomEvent } from '@/utils/event.ts';
import { hasUserInteractedWithPage } from '@/web-vitals';

const logger = getLogger('Laquesis/tracking');

function getExpDefinitionString() {
  const expDefinition = Array.from(state.activeExps)
    .map(([k, v]) => `"${k},${v}"`)
    .join(',');
  return `[${expDefinition}]`;
}

export function trackExpsAssignment() {
  dataLayer.push({
    trackEvent: LQ_EVENTS.TEST_ASSIGNMENT,
    test_definition: getExpDefinitionString(),
  });
}

export function trackFlagsAssignment() {
  const flagDefinition = `[${[...state.activeFlags].map(flag => `"${flag}"`).join(',')}]`;

  dataLayer.push({
    trackEvent: LQ_EVENTS.FLAG_ASSIGNMENT,
    flag_definition: flagDefinition,
  });
}

export function trackImpression(expName: string, variantName: string) {
  const lqDefinition = getLQDefinition();

  if (state.playgroundMode) {
    logger.debug(`Playground mode enabled for experiment ${expName}@${variantName}, triggering test_impression with env=playground`);
  } else {
    // If the session is not defined or mismatched, reset the tracked experiments
    if (!lqDefinition.currentSession || lqDefinition.currentSession !== state.currentSession?.session) {
      lqDefinition.currentSession = state.currentSession!.session;
      lqDefinition.trackedExperiments = '';
    } else if (lqDefinition.trackedExperiments && lqDefinition.trackedExperiments.includes(expName)) {
      // If the experiment is already tracked, return
      return;
    }

    // Append new experiment
    lqDefinition.trackedExperiments = lqDefinition.trackedExperiments ? lqDefinition.trackedExperiments + TEST_DIVIDER + expName : expName;

    writeLQDefinition(lqDefinition);
  }

  const params: ClickEvent = {
    trackEvent: LQ_EVENTS.TEST_IMPRESSION,
    test_name: expName,
    test_variation: variantName,
    user_uuid: state.userUUId,
    user_id: state.userId,
    laq_lft: lqDefinition.lastRefresh,
    laq_nft: lqDefinition.nextRefresh,
    test_definition: getExpDefinitionString(),
  };

  if (!hasUserInteractedWithPage) {
    // Needed for web vitals to be linked to experiments
    params.web_vital_page = state.firstTrackedPageEvent;
  }

  dataLayer.push(params);
  triggerCustomEvent(CUSTOM_EVENTS.LAQUESIS_EXP_IMPRESSION, {
    experiment: expName,
    variant: variantName,
  });

  logger.debug('Impression tracked', params);
}
